import { graphql } from 'msw';

/**
 * The web app will require the user to refresh if the returned directory version is different from
 * the last cached version. That means the actual value returned here is not important; it will only
 * have an effect if it changes between responses.
 */
export const getDirectoryVersion = graphql.query<
    GetDirectoryVersionQuery,
    GetDirectoryVersionQueryVariables
>('getDirectoryVersion', (req, res, ctx) =>
    res(
        ctx.data({
            getDirectoryVersion: 1,
        }),
    ),
);
